import * as React from 'react'
import { StyledSectionContainer, ModuleContentContainer, SecondaryTitle, TertiaryTitle } from '../shared/section'
import { colors } from '../../../utils/helpers/colors'
import LinkList from '../shared/LinkList'

const CityModule = ({ links }) => (
  <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
    <SecondaryTitle data-testid="secondary-title-pp">
      Retrouvez aussi <b>en France</b>
    </SecondaryTitle>
    <TertiaryTitle data-testid="tertiary-title-pp">Annonces {'immobilières'} par ville de France</TertiaryTitle>
    <ModuleContentContainer data-testid="module-content-pp">
      <LinkList links={links} wording={{ plural: 'liens' }} maxLinks={10} />
    </ModuleContentContainer>
  </StyledSectionContainer>
)

export default CityModule
